import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Logo from "../../assets/logo/logo.png";
// import Logo from "../../assets/logo/logo.png";
import { useAppContext } from "../../store/appContext";
import privacyChoicesIcon from "../../assets/icons/privacyChoicesIcon.png";
import { getCopyright } from "../../api/footer";
import RedirectPopup from "../redirectPopup";
declare global {
  interface Window {
    CassieWidgetLoader?: {
      Widget: {
        showModal: () => void;
      };
    };
  }
}

const Footer = () => {
  const [data, setData] = useState<any>();
  const [loading, setLoading] = useState(true);
  const { state, updateState } = useAppContext();
  const location = useLocation();
  const isContactPage = location.pathname === "/contact";
  const isSitemap = location.pathname === "/sitemap";
  const links = {
    termsOfUse: "https://privacynotice.lilly.com/terms-of-use/",
    privacyStatement: "https://privacynotice.lilly.com/",
    consumerHealthPrivacyNotice:
      "https://www.lillyhub.com/legal/lillyusa/chpn.html",
    accessibilityStatement: "https://privacynotice.lilly.com/accessibility/",
    // copyright: "https://lillyhub.com/legal/lillyusa/english/copyright.html",
    privacyChoices: "https://privacynotice.lilly.com/global/",
  };
  const handleCookieSettings = () => {
    if (window.CassieWidgetLoader) {
      window.CassieWidgetLoader.Widget.showModal();
    }
  };
  useEffect(() => {
    getCopyright().then((res) => {
      setData(res.data);
      setLoading(false);
    });
  }, []);
  return (
    <footer className="p-4 w-full border-t border-border-gray20">
      <div className="md:flex hidden justify-between">
        <div className="">
          {!isContactPage && 0 ? (
            <NavLink
              data-gtm-id="item-19"
              to="/contact"
              className="text-body-text-lilly_red underline"
            >
              Contact Us
            </NavLink>
          ) : (
            <div></div>
          )}
          <div className="py-4 text-sm">
            This site is intended for global audience aged 18 and older.
            <br />
            {!loading && (
              <RedirectPopup
                link={data.Link}
                data-gtm-id="item-20"
                target="_blank"
                rel="noopener noreferrer"
                className="text-body-text-lilly_red underline"
                content={data.Link_name}
                arialabel={`${data.Link_name} (opens in new tab)`}
              />
            )}
          </div>
        </div>
        <div>
          <div className="text-sm">
            {/* <NavLink
                    to=""
                    className="text-body-text-lilly_red underline font-medium"
                >
                    Copyright &copy; 2024 Lilly. All rights reserved.
                </NavLink> */}
          </div>
          <div className="w-full flex justify-end py-4 text-sm ">
            <RedirectPopup
              link={links.privacyChoices}
              data-gtm-id="item-21"
              target="_blank"
              rel="noopener noreferrer"
              className="text-body-text-lilly_red underline"
              arialabel="Your Privacy Choices (opens in new tab)"
              content={
                <div className="flex items-center gap-2">
                  <div className="">
                    <img
                      src={privacyChoicesIcon}
                      alt="privacy choices"
                      className="w-6"
                    />
                  </div>
                  <div data-gtm-id="item-5">Your Privacy Choices</div>
                </div>
              }
            />
          </div>
          <div className="w-full flex justify-end text-sm">
            <button
              data-gtm-id="item-7"
              className="text-body-text-lilly_red underline cursor-pointer bg-transparent border-none p-0"
              onClick={handleCookieSettings}
              type="button"
            >
              Cookie Settings
            </button>
          </div>
        </div>
      </div>
      <div className="w-full justify-between items-end lg:items-center md:flex hidden">
        <div>
          <img
            src={Logo}
            alt="Lilly Logo"
            className="h-8 -my-2"
            // className="h-8 mt-1"
          />
        </div>
        <div className="grow flex flex-col lg:flex-row lg:items-center items-end justify-end gap-4 pt-4 text-sm">
          <RedirectPopup
            link={links.termsOfUse}
            data-gtm-id="item-9"
            target="_blank"
            rel="noopener noreferrer"
            className="text-body-text-lilly_red underline"
            content="Terms of Use"
            arialabel="Terms of Use (opens in new tab)"
          />
          <RedirectPopup
            link={links.privacyStatement}
            data-gtm-id="item-11"
            target="_blank"
            rel="noopener noreferrer"
            className="text-body-text-lilly_red underline"
            content="Privacy Statement"
            arialabel="Privacy Statement (opens in new tab)"
          />
          <RedirectPopup
            link={links.consumerHealthPrivacyNotice}
            data-gtm-id="item-14"
            target="_blank"
            rel="noopener noreferrer"
            className="text-body-text-lilly_red underline"
            content="Consumer Health Privacy Notice"
            arialabel="Consumer Health Privacy Notice (opens in new tab)"
          />
          <RedirectPopup
            link={links.accessibilityStatement}
            data-gtm-id="item-15"
            target="_blank"
            rel="noopener noreferrer"
            className="text-body-text-lilly_red underline"
            content="Accessibility Statement"
            arialabel="Accessibility Statement (opens in new tab)"
          />
          {/* {!isSitemap && (
            <NavLink
              to="/sitemap"
              className="text-body-text-lilly_red underline"
            >
              Sitemap
            </NavLink>
          )} */}
        </div>
      </div>
      <div className="md:hidden">
        <div className="w-full flex flex-col items-center gap-4 text-sm">
          {!isContactPage && 0 ? (
            <NavLink
              to="/contact"
              className="text-body-text-lilly_red underline"
              data-gtm-id="item-22"
            >
              Contact Us
            </NavLink>
          ) : (
            <div></div>
          )}
          <RedirectPopup
            link={links.termsOfUse}
            target="_blank"
            rel="noopener noreferrer"
            className="text-body-text-lilly_red underline"
            content="Terms of Use"
            arialabel="terms of use (opens in new tab)"
            data-gtm-id="item-10"
          />
          <RedirectPopup
            link={links.privacyStatement}
            target="_blank"
            rel="noopener noreferrer"
            className="text-body-text-lilly_red underline"
            content="Privacy Statement"
            arialabel="privacy statements (opens in new tab)"
            data-gtm-id="item-12"
          />
          <RedirectPopup
            link={links.consumerHealthPrivacyNotice}
            target="_blank"
            rel="noopener noreferrer"
            className="text-body-text-lilly_red underline"
            content="Consumer Health Privacy Notice"
            arialabel="consumer health privacy notice (opens in new tab)"
            data-gtm-id="item-13"
          />
          <RedirectPopup
            link={links.accessibilityStatement}
            target="_blank"
            rel="noopener noreferrer"
            className="text-body-text-lilly_red underline"
            content="Accessibility Statement"
            arialabel="accessibility statement (opens in new tab)"
            data-gtm-id="item-16"
          />
          {/* {!isSitemap && (
            <NavLink
              to="/sitemap"
              className="text-body-text-lilly_red underline"
            >
              Sitemap
            </NavLink>
          )} */}
          <div className="text-center">
            This site is intended for global audience aged 18 and older.
          </div>
          {!loading && (
            <RedirectPopup
              link={data.Link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-body-text-lilly_red underline"
              content={data.Link_name}
              arialabel={`${data.Link_name} (opens in new tab)`}
              data-gtm-id="item-23"
            />
          )}
          {/* <div className="text-center">
            To speak to our customer support:
            <br />
            Call&nbsp;
            <span className="text-body-text-lilly_red underline">
              (800) 545-5979
            </span>
          </div> */}
          <RedirectPopup
            link={links.privacyChoices}
            data-gtm-id="item-24"
            target="_blank"
            rel="noopener noreferrer"
            className="text-body-text-lilly_red underline"
            arialabel="Your Privacy Choices (opens in new tab)"
            content={
              <div className="flex items-center gap-2">
                <div className="">
                  <img
                    src={privacyChoicesIcon}
                    alt="privacy choices"
                    className="w-6"
                  />
                </div>
                <div data-gtm-id="item-6">Your Privacy Choices</div>
              </div>
            }
          />
          <button
            className="text-body-text-lilly_red underline cursor-pointer bg-transparent border-none p-0"
            data-gtm-id="item-8"
            onClick={handleCookieSettings}
            type="button"
          >
            Cookie Settings
          </button>
          <div>
            <img src={Logo} alt="Lilly Logo" className=" h-8" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
